import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import useApp from "../../../hooks/useApp";
import useArea from "../../../hooks/useArea";

interface Props {
  timeSlot: any;
  settings: boolean;
}

const TimeSlotComponent: React.FC<Props> = ({ timeSlot, settings }) => {
  const areasTimeSlots = useSelector((state: any) => state.areas.timeSlots);
  const { showError } = useApp();
  const { areasChangeTimeSlots } = useArea("areas", "area");

  const handleClick = (event: any, id: string) => {
    if (settings) {
      const newSelect = new Set(areasTimeSlots);

      if (newSelect.has(id)) newSelect.delete(id);
      else newSelect.add(id);

      areasChangeTimeSlots(newSelect);
    } else {
      showError("Select Apply to selected days and timeSlots in order to edit");
    }
  };

  return (
    <Box
      sx={{
        display: "inline-block",
        border: "1px solid",
        borderColor: "grey.200",
        backgroundColor: areasTimeSlots.has(timeSlot.id)
          ? "common.black"
          : "transparent",
        color: (theme) =>
          areasTimeSlots.has(timeSlot.id)
            ? "common.white"
            : theme.palette.text.primary,
        p: { xs: "4px 8px", md: "4px 8px" },
        m: "0px 4px",
        cursor: "pointer",
      }}
      onClick={(event: any) => handleClick(event, timeSlot.id)}
    >
      <Typography component="span" variant="body2">
        {timeSlot.friendlyName}
      </Typography>
    </Box>
  );
};

export default TimeSlotComponent;
